export default __webpack_public_path__ + "static/media/thunder.7432b75d.svg";